import { RESERVATION_CONSENT_CHECK_LIFETIME_MILLISECONDS } from '@shared/constants/reservation';
import type { ReservationConsentCheck } from '@shared/types';

export const isReservationConsentCheckFresh = (
  check: ReservationConsentCheck | undefined,
  ownerId: string | undefined,
  nowTimestamp: number
): check is ReservationConsentCheck => {
  if (!check) return false;
  if (check.ownerId !== ownerId) return false;
  return nowTimestamp - check.checkedAtTimestamp < RESERVATION_CONSENT_CHECK_LIFETIME_MILLISECONDS;
};
